import { IpsMelissaValidation } from '../../models/appliance-details-stepped/ips-melissa-validation.interface';

export const mockIpsMelissaValidation: IpsMelissaValidation = {
  isValid: true,
  resultCodes: 'resultCodes',
};
